import { render, staticRenderFns } from "./productBrand.vue?vue&type=template&id=2a64a39c&scoped=true"
import script from "./productBrand.vue?vue&type=script&lang=js"
export * from "./productBrand.vue?vue&type=script&lang=js"
import style0 from "./productBrand.vue?vue&type=style&index=0&id=2a64a39c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a64a39c",
  null
  
)

export default component.exports